import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { PhoneAppealState } from "project-config/constants/user-info";

export function PhoneStatus({ status }: { status?: PhoneAppealState }) {
  const { t } = useTranslation("profile");
  if (typeof status === "undefined") {
    return null;
  }

  return (
    <PhoneStatusWrapper className={`status-${status}`}>
      {t(`phone_appeal_state_${status}`)}
    </PhoneStatusWrapper>
  );
}

const PhoneStatusWrapper = styled.div`
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  border-radius: 2px;
  &.status-0 {
    background: #308fff;
  }
  &.status-1 {
    background: #13cb75;
  }
  &.status-2 {
    background: #bfc2c4;
  }
`;
